import React, { createContext, useContext, useState } from 'react';

const SubmitBusinessContext = createContext();

export const useSubmitBusiness = () => {
  const context = useContext(SubmitBusinessContext);
  if (!context) {
    throw new Error('useSubmitBusiness must be used within SubmitBusinessProvider');
  }
  return context;
};

export const SubmitBusinessProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialData, setInitialData] = useState(null);

  const openModal = (data = null) => {
    setInitialData(data);
    setIsOpen(true);
  };
  const closeModal = () => {
    setInitialData(null);
    setIsOpen(false);
  };

  return (
    <SubmitBusinessContext.Provider value={{ isOpen, openModal, closeModal, initialData }}>
      {children}
    </SubmitBusinessContext.Provider>
  );
};
